import { useBreakpoints } from "@vueuse/core";
import { computed } from "vue-demi";
import { APP_IMAGE_BREAKPOINTS } from "./constants.mjs";
const DEFAULT_RESOLUTIONS = {
  desktop: {
    width: 1344,
    height: 400
  },
  tablet: {
    width: 976,
    height: 350
  },
  mobile: {
    width: 640,
    height: 400
  }
};
const getResolutionByBreakpoint = (breakpoint, customResolutions) => {
  const defaultResolution = DEFAULT_RESOLUTIONS[breakpoint];
  const customResolution = customResolutions?.[breakpoint];
  const resolution = {
    width: customResolution?.width || defaultResolution.width,
    height: customResolution?.height || defaultResolution.height
  };
  return resolution;
};
const useImageResolution = (customResolutions) => {
  const breakpoints = useBreakpoints(APP_IMAGE_BREAKPOINTS);
  const isMobile = breakpoints.smallerOrEqual("mobile");
  const isTablet = computed(
    () => breakpoints.greater("mobile").value && breakpoints.smallerOrEqual("tablet").value
  );
  const isDesktop = breakpoints.greater("tablet");
  const activeBreakpoint = computed(() => {
    if (isMobile.value)
      return "mobile";
    if (isTablet.value)
      return "tablet";
    if (isDesktop.value)
      return "desktop";
    return "desktop";
  });
  const imageResolution = computed(
    () => getResolutionByBreakpoint(activeBreakpoint.value, customResolutions)
  );
  return {
    imageResolution,
    isMobile,
    isTablet,
    isDesktop
  };
};
export default useImageResolution;
